import ztComponent from './ztDropdown.vue'
import ztComponentChild from './ztDropdownItem.vue'
import ztComponentSubChild from './ztDropdownSubItem.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
  Vue.component(ztComponentChild.name, ztComponentChild)
  Vue.component(ztComponentSubChild.name, ztComponentSubChild)
}
